import { createBrowserRouter } from "react-router-dom";
import HomePage from '../pages/HomePage'
import DetailProduct from '../pages/DetailProduct'
import Template from "../components/Template";

const router = createBrowserRouter([
  {
    path: '/',
    element: <Template />,
    children: [
      {
        path: '',
        element: <HomePage />
      },
      {
        path: 'product/:id',
        element: <DetailProduct />
      }
    ]
  },
  // {
  //   path: '/login',
  //   element: <LoginPage />,
  // }
]);

export default router